(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    	.controller('LoginController', login);

  login.$inject = ['$scope', '$location', 'LangService', 'AuthenticationService', 'UserService', '$http', 'LoginService', '$rootScope', 'LocalStorageService', 'NotificationFactory'];

  function login ($scope, $location, LangService, AuthenticationService, UserService, $http, LoginService, $rootScope, LocalStorageService, NotificationFactory) {
    var vm = this;

    if (localStorage.getItem('language')) {
      vm.language = localStorage.getItem('language');
    } else {
      vm.language = 'pt';
      localStorage.setItem('language', 'pt');
    }

    	$scope.vm = vm;

    if ($rootScope.changepassword) {
      $scope.vm.changepassword = 1;
    }

    AuthenticationService.ClearCredentials();
    vm.username = vm.password = '';
    var l = Ladda.create(angular.element('#login_btnLogin')[0]);
    var notifSet = new NotificationFactory({
      position: 'bottom-right'
    });

    vm.doLogin = doLogin;
    $rootScope.$on('illegal_token', function (data) {
      var message = vm.labels.errorIlegalOperation;
      notifSet.addNotification({ title: 'Ops!', content: message, autoclose: '10000', color: 'alert' });
    })

    function doLogin () {
      var username = vm.username;
      var password = vm.password;
      l.start();
      AuthenticationService.Login(username, password, function (response) {
        if (response.success) {
          $scope.success = true;
          AuthenticationService.SetCredentials(username, response.token);
          if (response.change_warning) {
            alert(response.change_warning);
          }
          if (response.reset_password) {
            vm.resetpassword = true;
            alert(vm.labels.expiredPassword);
          }

          if (response.change == 1) {
            vm.changepassword = true;
            vm.showCpfField = response.showCpfField;
          } else {
            LocalStorageService.clearUserPauseState();

            if (response.canSeeChats) {
              $location.path(frontUrl + '/chat');
            } else if (response.canSeeMessagesPortal) {
              $location.path(frontUrl + '/messages-portal/send');
            } else {
              $location.path(frontUrl + '/my-account');
            }
          }
        } else {
          var message = vm.labels.invalidEmailPassword;
          if (response.message) {
            message = response.message
          }
          vm.error = message;
          l.stop();
        }
      }, function (data) {
        if (!$scope.success) {
          vm.error = vm.labels.errorAccessAccount;
          l.stop();
        }
      });
    }

    vm.successLogin = function (username, response) {
      $scope.success = true;
      AuthenticationService.SetCredentials(username, response.token);
      if (response.change_warning) {
        alert(response.change_warning);
      }
      if (response.reset_password) {
        vm.resetpassword = true;
        alert(vm.labels.expiredPassword);
      }

      if (response.change == 1) {
        vm.changepassword = true;
      } else {
        LocalStorageService.clearUserPauseState();
        if (response.role == 2) { // Promotor
          $location.path(frontUrl + '/messages-portal/send');
        } else {
          $location.path(frontUrl + '/chat');
        }
      }
    };

    vm.errorLogin = function (response) {
      var message = vm.labels.invalidEmailPassword;
      if (response.message) {
        message = response.message
      }
      vm.error = message;
      l.stop();
    };

    vm.changePassword = function () {
      vm.change_password.old = vm.password;

      UserService.changePassword({ password: vm.change_password },
        function (response) {
          if (response.error) {
            vm.error_new_password = response.message;
            return;
          }

          if (response.canSeeChats) {
            $location.path(frontUrl + '/chat');
          } else if (response.canSeeMessagesPortal) {
            $location.path(frontUrl + '/messages-portal/send');
          } else {
            $location.path(frontUrl + '/my-account');
          }
        }, function (error) {
          vm.error_new_password = vm.labels.errorAlterPassword;
        })
    }

    vm.recoverPassword = function () {
      vm.error = null;
      if (!vm.username) {
        vm.error = vm.labels.fillUserAccount;
        return;
      }
      LoginService.recoverPassword({
        email: vm.username
      })
        .$promise
        .then(function (data) {
          if (data.error) {
            vm.error = data.message;
          } else {
            vm.success = vm.labels.verifyYourEmail;
          }
        }).catch(function (error) {
            	vm.error = vm.labels.errorRecoverPassword;
        })
    };

    vm.changeLanguage = function () {
      LangService
        .getLoginLabels({ 'locale': vm.language })
        .$promise
        .then(function (data) {
          vm.labels = data.lang;
          localStorage.setItem('language', vm.language);
        });
    }
    vm.changeLanguage();
  }
})();
